import moment from "moment";

export const checkIfDayOff = (dayOff, date) => {
  // date is a moment object
  const dayOffStart = moment.unix(dayOff.start).utc();
  const dayOffEnd = moment.unix(dayOff.end).utc();

  if (date.isBefore(dayOffStart)) {
    return false;
  }

  if (dayOff.repeat_yearly) {
    const isDayOffMultiYear = dayOffStart.year() !== dayOffEnd.year();
    const isDateInFirstHalfOfTheYear = date.month() < 6;

    dayOffStart.year(date.year());
    dayOffEnd.year(date.year());

    if (isDayOffMultiYear) {
      if (isDateInFirstHalfOfTheYear) {
        dayOffStart.year(date.year() - 1);
      } else {
        dayOffEnd.year(date.year() + 1);
      }
    }
  }

  return date.isBetween(dayOffStart, dayOffEnd, null, `[]`);
};
